import React from 'react'
import { gql } from '@apollo/client'
import { FaqBannerFragment } from './__generated__/SecondaryBanner'
import { SecondaryPageBanner } from '../../../fragments/secondaryPageBanner'
import { Breadcrumb, Breadcrumbs } from '../../../components/breadcrumbs/Breadcrumbs'

export type SecondaryPageBannerProps = {
  layout: 'vertical' | 'horizontal'
  secondaryPageBanner?: FaqBannerFragment[]
}

export const FAQBanner: React.VFC<SecondaryPageBannerProps> = ({ secondaryPageBanner }) => {
  if (!secondaryPageBanner?.[0]) {
    return null
  }

  const { bannerTitle, bannerSubtext, bannerButton } = secondaryPageBanner[0]

  return (
    <SecondaryPageBanner
      title={bannerTitle}
      subTitle={bannerSubtext}
      primaryButton={bannerButton}
      secondaryButton={undefined}
      //@ts-ignore
      image={undefined}
      breadcrumbs={(
        <Breadcrumbs>
          <Breadcrumb href={'/'} home text={'Home'} />
          <Breadcrumb href={'/help-and-support'} text={'Help and Support'} />
          <Breadcrumb href={'/help-and-support/faqs'} text={'FAQs'} />
        </Breadcrumbs>
      )}
    />
  )
}

export const SECONDARY_BANNER_FRAGMENT = gql`
  fragment FaqBannerFragment on faqBanner_BlockType {
    bannerTitle
    bannerSubtext
    bannerButton {
      url
      customText
      target
    }
  }
`